export default class ExamGenerationForm {
    public promptId: number = null
    public body: string
}